// Access token is intentionally stored in sessionStorage (not cookies) to avoid
// exposing non-HttpOnly auth cookies to XSS cookie theft checks.
const setAccessTokenCookie = (accessToken) => {
  sessionStorage.setItem('accessToken', accessToken);
}

const setUserDetails = (userDetails) => {
  localStorage.setItem('PVLUserDetails', userDetails);
}

const getAccessTokenCookie = () => {
  return sessionStorage.getItem('accessToken');
}

// const setRefreshToken = (refreshToken) => {
//     localStorage.setItem('refreshToken', refreshToken);
// }
// Refresh token is managed by backend as HttpOnly cookie.
const setRefreshToken = (_refreshToken) => {
  return;
}
const getRefreshToken = () => {
    return null;
}

const getUserDetails = () => {
  return localStorage.getItem('PVLUserDetails');
}

const removeAccessTokenCookie = () => {
  sessionStorage.removeItem('accessToken');
}
const removeRefreshToken = () => {
    return;
}

const removeUserDetails = () => {
  localStorage.removeItem('PVLUserDetails');
  // cookies.remove('userDetails');
}

const setCurrentCredits = (credits) => {
  localStorage.setItem('PVLCreditsAmount', credits);
}


export {
    setAccessTokenCookie,
    getAccessTokenCookie,
    removeAccessTokenCookie,
    setRefreshToken,
    getRefreshToken,
    removeRefreshToken,
    setUserDetails,
    getUserDetails,
    removeUserDetails,
    setCurrentCredits
  };